import { FirebaseMessaging } from "@capacitor-firebase/messaging";
import { Capacitor } from "@capacitor/core";
import store from "../store";
// import { showToast } from "../utils/helpers";

export default {
  methods: {
    async registerFCM() {
      if (!Capacitor.isNativePlatform()) {
        console.log("Web environment detected, skipping FCM setup");
        return;
      }
      try {
        let permStatus = await FirebaseMessaging.checkPermissions();
        if (permStatus.receive === "prompt") {
          permStatus = await FirebaseMessaging.requestPermissions();
        }

        if (permStatus.receive !== "granted") {
          throw new Error("User denied notification permissions");
        }
        console.log("Permission granted ✅");
        const { token } = await FirebaseMessaging.getToken();
        store.commit("userVUEX/setMobileToken", {
          token: token,
          platform: Capacitor.getPlatform(),
        });
        await FirebaseMessaging.addListener(
          "notificationReceived",
          (notification) => {
            console.log("Notification received: ", notification);
            // showToast('Notification');
            // store.commit("userVUEX/setNotificationRedirect", notification.notification.data)
          }
        );

        await FirebaseMessaging.addListener(
          "notificationActionPerformed",
          (notification) => {
            console.log("Notification action performed: ", notification);
            // showToast('Notification');
            // store.commit("userVUEX/setNotificationRedirect", notification.notification.data)
          }
        );
      } catch (err) {
        console.error("Error during FCM setup:", err);
      }
    },
  },
  mounted() {
    // clearCookies();
    this.registerFCM();
  },
};
